exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-bar-material-dialog .el-dialog__body{padding-bottom:0}", ""]);

// exports
